<template>
  <h1 class="text-center">{{ $t("home") | capitalize-first }}</h1>
</template>

<script>
export default {
}
</script>

<style>

</style>
